"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var i0 = require("./registration-holder.component.scss.shim.ngstyle");
var i1 = require("@angular/core");
var i2 = require("./registration-holder.component");
var i3 = require("@angular/material/dialog");
var styles_RegistrationHolderComponent = [i0.styles];
var RenderType_RegistrationHolderComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_RegistrationHolderComponent, data: {} });
exports.RenderType_RegistrationHolderComponent = RenderType_RegistrationHolderComponent;
function View_RegistrationHolderComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
exports.View_RegistrationHolderComponent_0 = View_RegistrationHolderComponent_0;
function View_RegistrationHolderComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-registration-holder", [], null, null, null, View_RegistrationHolderComponent_0, RenderType_RegistrationHolderComponent)), i1.ɵdid(1, 4308992, null, 0, i2.RegistrationHolderComponent, [i3.MatDialog], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
exports.View_RegistrationHolderComponent_Host_0 = View_RegistrationHolderComponent_Host_0;
var RegistrationHolderComponentNgFactory = i1.ɵccf("app-registration-holder", i2.RegistrationHolderComponent, View_RegistrationHolderComponent_Host_0, {}, {}, []);
exports.RegistrationHolderComponentNgFactory = RegistrationHolderComponentNgFactory;
